/**
 * Launcher API client for Zoo Galaxy
 * Uses HTTP-only cookies for authentication (set by launcher on login)
 */

const LAUNCHER_URL = import.meta.env.VITE_LAUNCHER_URL || 'https://vovan-space.space';

/**
 * Get launcher URL (for navigation)
 */
export const getLauncherUrl = (): string => LAUNCHER_URL;

/**
 * Check if user is authenticated (cookie exists)
 * Note: We can't read HTTP-only cookies, so we check by making an API call
 */
export const isAuthenticated = async (): Promise<boolean> => {
  const profile = await fetchProfile();
  return profile !== null;
};

/**
 * Fetch user profile from launcher
 * Cookie is sent automatically with credentials: 'include'
 */
export const fetchProfile = async (): Promise<{ name: string; role?: string } | null> => {
  try {
    const response = await fetch(`${LAUNCHER_URL}/api/profile`, {
      method: 'GET',
      credentials: 'include', // Send cookies cross-origin
      headers: {
        'X-Mission-Source': 'zoo-galaxy',
      },
    });

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch profile:', error);
    return null;
  }
};

/**
 * @deprecated Use cookies now - this is kept for backward compatibility during migration
 */
export const getSessionToken = (): string | null => {
  // Check URL for legacy support
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  if (urlToken) {
    // Clean URL (remove token from URL bar)
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url.toString());
  }
  return null; // Cookies handle auth now
};
